import { render, staticRenderFns } from "./UpdateSSHPort.vue?vue&type=template&id=2bc5bfe0&scoped=true"
import script from "./UpdateSSHPort.vue?vue&type=script&lang=js"
export * from "./UpdateSSHPort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5bfe0",
  null
  
)

export default component.exports